import { render, staticRenderFns } from "./MiniAlerts.vue?vue&type=template&id=7742b630"
import script from "./MiniAlerts.vue?vue&type=script&lang=js"
export * from "./MiniAlerts.vue?vue&type=script&lang=js"
import style0 from "./MiniAlerts.vue?vue&type=style&index=0&id=7742b630&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports